import {
    AcademicCapIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ChatBubbleLeftRightIcon,
    DocumentTextIcon,
    SparklesIcon,
    SquaresPlusIcon,
} from "@heroicons/react/24/outline";
import { bookingUrl } from "./ConsultationBooking";

const options = [
    {
        title: "Վերապատրաստումներ",
        description: "Մասնակցեք մասնագիտական զարգացման ծրագրերին և դասընթացներին։",
        icon: AcademicCapIcon,
        href: "/?page=service&form=training",
        internal: true,
        available: true,
        color: "bg-emerald-700",
    },
    {
        title: "Սցենար",
        description: "Բացահայտեք կրթական միջոցառումների պատրաստի գաղափարներ և սցենարներ։",
        icon: DocumentTextIcon,
        href: "/?page=service&form=scenario",
        internal: true,
        available: true,
        color: "bg-amber-500",
    },
    {
        title: "Դասի պլան",
        description: "Ստացեք ձեր դասին համապատասխան պատրաստի պլան։",
        icon: SparklesIcon,
        href: "/?page=service&form=lesson-plan",
        internal: true,
        available: true,
        color: "bg-sky-600",
    },
    {
        title: "Խորհրդատվություն",
        description: "Ստացեք մասնագիտական ուղղորդում կրթական ոլորտին վերաբերող հարցերի շուրջ։",
        icon: ChatBubbleLeftRightIcon,
        href: "/?page=consultation",
        internal: true,
        available: true,
        color: "bg-violet-600",
    },
    {
        title: "Կրթական ոլորտի այլ ծառայություն",
        description: "Գտեք ձեր նպատակներին համապատասխան կրթական ծառայությունը։",
        icon: SquaresPlusIcon,
        href: "/?page=service&form=other",
        internal: true,
        available: true,
        color: "bg-rose-600",
    },
];

export default function ApplicationForm() {
    return (
        <main className="relative min-h-screen overflow-hidden bg-slate-50 px-4 py-8 sm:px-6 sm:py-12">
            <iframe
                src={bookingUrl}
                title="Խորհրդատվության օրացույցի նախաբեռնում"
                tabIndex="-1"
                aria-hidden="true"
                credentialless=""
                className="pointer-events-none absolute -left-[9999px] h-px w-px opacity-0"
            />
            <div className="pointer-events-none absolute -left-32 -top-32 h-80 w-80 rounded-full bg-emerald-100 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-32 -right-24 h-96 w-96 rounded-full bg-sky-100 blur-3xl" />

            <div className="relative mx-auto max-w-6xl">
                <a
                    href="/"
                    className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm ring-1 ring-slate-200 transition hover:-translate-x-1 hover:text-emerald-700"
                >
                    <ArrowLeftIcon className="h-4 w-4" />
                    Գլխավոր էջ
                </a>

                <section className="mx-auto mt-12 max-w-3xl text-center sm:mt-16">
                    <span className="inline-flex rounded-full bg-emerald-100 px-4 py-2 text-sm font-bold text-emerald-800">
                        Կրթություն և զարգացում
                    </span>
                    <h1 className="mt-6 text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">
                        Ընտրեք բաժինը
                    </h1>
                    <p className="mx-auto mt-5 max-w-2xl text-lg leading-8 text-slate-600">
                        Մեկ պարզ քայլ՝ անհրաժեշտ ծառայությանը կամ ծրագրին հասնելու համար։
                    </p>
                </section>

                <section className="mt-12 grid gap-6 md:grid-cols-3 sm:mt-16">
                    {options.map((option) => {
                        const Icon = option.icon;
                        const content = (
                            <>
                                <div className={`flex h-14 w-14 items-center justify-center rounded-2xl text-white shadow-sm ${option.color}`}>
                                    <Icon className="h-7 w-7" />
                                </div>

                                <div className="mt-7 flex items-start justify-between gap-4">
                                    <h2 className="text-2xl font-bold leading-8 text-slate-900">
                                        {option.title}
                                    </h2>
                                    {!option.available && (
                                        <span className="shrink-0 rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-500">
                                            Շուտով
                                        </span>
                                    )}
                                </div>

                                <p className="mt-4 flex-1 text-base leading-7 text-slate-600">
                                    {option.description}
                                </p>

                                <div className={`mt-8 inline-flex items-center gap-2 font-bold ${option.available ? "text-emerald-700" : "text-slate-400"}`}>
                                    {option.available ? "Բացել հայտը" : "Բաժինը պատրաստվում է"}
                                    {option.available && <ArrowRightIcon className="h-5 w-5" />}
                                </div>
                            </>
                        );

                        const cardClasses = `flex min-h-80 flex-col rounded-3xl border bg-white p-7 shadow-sm transition sm:p-8 ${
                            option.available
                                ? "border-emerald-100 hover:-translate-y-2 hover:border-emerald-300 hover:shadow-xl"
                                : "border-slate-200"
                        }`;

                        return option.available ? (
                            <a
                                key={option.title}
                                href={option.href}
                                target={option.internal ? undefined : "_blank"}
                                rel={option.internal ? undefined : "noreferrer"}
                                className={cardClasses}
                            >
                                {content}
                            </a>
                        ) : (
                            <article key={option.title} className={cardClasses}>
                                {content}
                            </article>
                        );
                    })}
                </section>
            </div>
        </main>
    );
}
